var path = '/forms/directives/form-message.html';
var html = "<md-toast class=\"custom {{type}}\"> <div class=md-toast-content> <span role=alert aria-relevant=all aria-atomic=true ng-transclude></span> </div> </md-toast> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./forms/directives/form-message.html
// module id = 106
// module chunks = 0